<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="true"
      :hideEdit="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
    />
  </div>
</template>

<script>
import ButtonOptions from '@/components/directives/button-options';

export default {
  name: 'LandmarkEdit',
  components: { ButtonOptions },
  props: {
    access: {
      type: String,
      default: '',
    },
    landmark: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    data() {
      return { ...this.landmark };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.data);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.data);
    },
  },
};
</script>

<style scoped></style>
